const ENABLED = process.env.NODE_ENV === "development";

export class VoiceModeLogger {
  private readonly namespace: string;

  constructor(namespace: string) {
    this.namespace = namespace;
  }

  public log(message: string, ...data: unknown[]): void {
    if (!ENABLED) {
      return;
    }
    // oxlint-disable-next-line no-console
    console.log(
      `%c${this.namespace}%c ${message}`,
      STYLES.log.badge,
      STYLES.log.message,
      ...data
    );
  }

  public warn(message: string, ...data: unknown[]): void {
    if (!ENABLED) {
      return;
    }
    // oxlint-disable-next-line no-console
    console.warn(
      `%c${this.namespace}%c ${message}`,
      STYLES.warn.badge,
      STYLES.warn.message,
      ...data
    );
  }

  public error(message: string, ...data: unknown[]): void {
    if (!ENABLED) {
      return;
    }
    // oxlint-disable-next-line no-console
    console.error(
      `%c${this.namespace}%c ${message}`,
      STYLES.error.badge,
      STYLES.error.message,
      ...data
    );
  }
}

const BADGE_BASE =
  "color: #fff; padding: 1px 6px; border-radius: 3px; font-weight: 600;";

const STYLES = {
  log: {
    badge: `${BADGE_BASE} background: #6366f1;`,
    message: "color: inherit;",
  },
  warn: {
    badge: `${BADGE_BASE} background: #d97706;`,
    message: "color: #b45309;",
  },
  error: {
    badge: `${BADGE_BASE} background: #dc2626;`,
    message: "color: #b91c1c;",
  },
} as const;
